<template>
        <div class="page_404">
        	<div class="info">
        		<p>哎呀，页面不存在...</p>
        		<p>休息一下,继续访问</p>
        		<router-link to="/">回到首页</router-link>
        	</div>
        </div>
</template>
<script>
	export default {
		data() {
			return {
			    
			}
		}
	}
</script>
<style lang="scss" scoped>
	.page_404{
		min-width: 1000px;
		min-height: 800px;
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
        background: url(../../assets/img/404.svg) center center no-repeat;
        background-size: 100% auto;
        .info{
        	position: absolute;
        	left: 10%;
        	bottom: 50%;
        	p{
        		font-size: 24px;
        		color: #8a8a8a;
        		padding-bottom: 20px;
        	}
        	p:first-child{
        		color: #424242;
        		font-size: 36px;
        	}
        	p:nth-child(2){
        		padding-bottom: 30px;
        	}
        	a{
        		display: block;
        		width: 120px;
        		height: 46px;
        		border-radius: 4px;
        		background: #1AB394;
        		color: #fff;
        		line-height: 46px;
        		text-align: center;
        		font-size: 16px;
        		&:hover{
        			background: #5ecab4;
        		}
        	}
        }
	}
</style>